import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

const colors = {
  blue: '#0269C9',
  yellow: '#C9C102',
  red: '#D76161',
  green: '#61D77B',
  grey: '#C4C4C4',
};

export const ActionButtonAccept = withStyles({
  root: {
    color: '#ffffff',
    backgroundColor: colors.blue,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '1rem',
    padding: '10px',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: colors.blue,
    },
  },
})(Button);

export const ActionButtonReject = withStyles({
  root: {
    color: '#ffffff',
    backgroundColor: colors.red,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    padding: '10px',
    lineHeight: '1rem',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: colors.red,
    },
  },
})(Button);

export const ActionButtonComplete = withStyles({
  root: {
    color: '#ffffff',
    backgroundColor: colors.blue,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '1rem',
    padding: '10px',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: colors.blue,
    },
  },
})(Button);

export const ActionButtonDiscard = withStyles({
  root: {
    color: '#ffffff',
    backgroundColor: colors.grey,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    padding: '10px',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: colors.grey,
    },
  },
})(Button);

export const LocationText = withStyles({
  root: {
    color: '#ffffff',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fontSize: '1.4rem',
    padding: '10px',
    '&:hover': {
      color: '#ffffff',
    },
  },
})(Typography);

export const UserText = withStyles({
  root: {
    color: '#211543',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    '&:hover': {
      color: '#211543',
    },
  },
})(Typography);

export const OrderIdText = withStyles({
  root: {
    color: '#00000087',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    padding: '2px',
    '&:hover': {
      color: '#00000087',
    },
  },
})(Typography);

export const ProductText = withStyles({
  root: {
    color: '#000000A4',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    padding: '2px',
    letterSpacing: '-0.025em',
    textAlign: 'start',
    '&:hover': {
      color: '#000000A4',
    },
  },
})(Typography);

export const ProductTextWhite = withStyles({
  root: {
    color: '#ffffff',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: '0.8rem',
    padding: '2px',
    letterSpacing: '-0.025em',
    textAlign: 'start',
    '&:hover': {
      color: '#ffffff',
    },
  },
})(Typography);
